module.exports = __webpack_public_path__ + "img/6.8516ed09.jpg";